import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  loadingContractInfra: true,
  contractInfra: null,
  errorContractInfra: null,
}

// mutations
export const mutations = {
  [types.GET_CONTRACT_INFRA_START] (state) {
    state.loadingContractInfra = true
    state.contractInfra = null
    state.errorContractInfra = null
  },

  [types.GET_CONTRACT_INFRA_SUCCESS] (state, { data }) {
    state.loadingContractInfra = false
    state.contractInfra = data
    state.errorContractInfra = null
  },

  [types.GET_CONTRACT_INFRA_ERROR] (state, { error }) {
    state.loadingContractInfra = false
    state.contractInfra = null
    state.errorContractInfra = error
  },
}

export const actions = {
  async getContractInfra ({ commit }, contractId) {
    try {
      commit(types.GET_CONTRACT_INFRA_START)

      const { data } = await axios.get(`/api/infras_contract/find/${contractId}`)

      commit(types.GET_CONTRACT_INFRA_SUCCESS, { data })
    } catch (e) {
      const { response } = e
      commit(types.GET_CONTRACT_INFRA_ERROR, { error: response })
    }
  },
}

// getters
export const getters = {
  loadingContractInfra: state => state.loadingContractInfra,
  contractInfra: state => state.contractInfra,
  errorContractInfra: state => state.errorContractInfra,
}
